import { useCallback } from 'react';
import { generatePath, Path, useNavigate } from 'react-router-dom';

import { AgreementReadModel, CreateAgreementPayload, usePostAgreementsMutation } from '@client/api';

import { blockApp, resumeApp } from '../../redux';
import { useAppDispatch } from '../useAppDispatch';

type UseCreateAgreementCreateOptions = {
  path?: Partial<Path>;
};

export const useCreateAgreement = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [mutation, result] = usePostAgreementsMutation();

  const create = useCallback(
    async (payload?: Partial<CreateAgreementPayload>, options?: UseCreateAgreementCreateOptions) => {
      dispatch(blockApp());

      let createdItem: AgreementReadModel | undefined;
      try {
        createdItem = await mutation({
          body: { status: 'Draft', spaces: [], ...payload },
        }).unwrap();
      } catch (e) {
        /** empty */
      }

      dispatch(resumeApp());

      if (createdItem == null) return;

      navigate({
        pathname: generatePath('/agreements/:id', { id: createdItem.id }),
        ...(options?.path || {}),
      });
    },
    [dispatch, navigate, mutation],
  );

  return { create, ...result };
};
